module.exports = __webpack_public_path__ + "0af5d249/img/comments-icon.fdec7fdb.svg";